import { RoleDTO } from '@/core/api/sicom-api/sistema/roles/roles-admin.model';
import { roleValida } from '../roles-agrupamento.util';

/** Roles de acesso/sistema do Keycloak que NÃO são permissões de catálogo — não contam como órfãs. */
export const ROLES_ACESSO_SISTEMA: readonly string[] = ['usuario-sicom'];

export interface DiagnosticoContadores {
    sincronia: number;
    orfas: number;
    faltando: number;
    foraPadrao: number;
    acesso: number;
}

export interface DiagnosticoResultado {
    inventario: RoleDTO[]; // roles do Keycloak p/ o kanban (padrão ok, não-acesso)
    orfas: Set<string>; // ∈ Keycloak, ∉ catálogo
    faltando: string[]; // ∈ catálogo, ∉ Keycloak
    foraPadrao: string[]; // ∈ Keycloak, fora do PADRAO_ROLE
    acesso: string[]; // gates ignorados
    contadores: DiagnosticoContadores;
}

/** Confronta as roles do Keycloak com o catálogo do app: aponta órfãs, faltantes e o inventário resultante. */
export function diagnosticar(inventarioKc: RoleDTO[], catalogo: string[], acessoSistema: readonly string[] = ROLES_ACESSO_SISTEMA): DiagnosticoResultado {
    const catSet = new Set(catalogo);
    const acessoSet = new Set(acessoSistema);

    const inventario: RoleDTO[] = [];
    const orfas = new Set<string>();
    const foraPadrao: string[] = [];
    const acesso: string[] = [];
    let sincronia = 0;

    for (const r of inventarioKc) {
        const name = r.name ?? '';
        if (acessoSet.has(name)) {
            acesso.push(name);
            continue;
        }
        if (!roleValida(name)) {
            foraPadrao.push(name);
            continue;
        }
        inventario.push(r);
        if (catSet.has(name)) sincronia++;
        else orfas.add(name);
    }

    const kcNames = new Set(inventarioKc.map((r) => r.name));
    const faltando = catalogo.filter((c) => !kcNames.has(c)).sort();

    return {
        inventario,
        orfas,
        faltando,
        foraPadrao: foraPadrao.sort(),
        acesso: acesso.sort(),
        contadores: {
            sincronia,
            orfas: orfas.size,
            faltando: faltando.length,
            foraPadrao: foraPadrao.length,
            acesso: acesso.length
        }
    };
}
